<template>
  <div id="svgContent" class="photovoltaicDiagram">
    <div class="title">
      <!-- <el-cascader v-model="cascaderValue" :options="cascaderOptions" :props="{ expandTrigger: 'hover' }"
        @change="handleChange"></el-cascader> -->
      <el-select v-model="svgUrl" placeholder="请选择">
        <el-option v-for="item, index in options" :key="`${item.id}-${index}`" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="content">
      <SvgD3 :key="svgKey" svgId="svgPhotovoltaicDiagram" :svgUrl="svgUrl" :svgUrlType="svgUrlType" />
    </div>
  </div>
</template>

<script>
import SvgD3 from "@/components/Svg/SvgD3";
import api from "@/api";
import {
  getSvgOptions,
  getProjectVal,
} from "@/assets/js/utils";
export default {
  name: "PhotovoltaicDiagram",
  components: { SvgD3 },
  data() {
    return {
      // cascaderValue: ["1", '@/assets/images/svg/diagram02.svg'],
      // cascaderOptions: [{
      //   value: '1',
      //   label: '一号电站',
      //   children: [{
      //     value: '@/assets/images/svg/diagram01.svg',
      //     label: 'diagram',
      //   },
      //   {
      //     value: 'full',
      //     label: '全景图',
      //   }, {
      //     value: 'networking',
      //     label: '组网图',
      //   }
      //   ]
      // }],
      svgKey: 1,
      // options: [{
      //   value: '@/assets/images/svg/diagram02.svg',
      //   name: '1#/2#/3#/4#宿舍楼',
      // }, {
      //   value: '@/assets/images/svg/diagram03.svg',
      //   name: '5#宿舍楼',
      // }, {
      //   value: '@/assets/images/svg/diagram01.svg',
      //   name: '行政楼/8#宿舍楼',
      // }],
      // svgUrl: "@/assets/images/svg/diagram02.svg",
      options: [],
      svgUrl: "@/assets/images/svg/empty.svg",
    }
  },
  methods: {
    handleChange(val) {
      console.log('handleChange---', val);
    },
    //selectOptions
    async getStationAttrs() {
      let res = await api.svgGetStationAttrs({
        projectId: getProjectVal('Id'),
        attributes: 'DistributionDiagram'
      });
      if (res && res.data?.code == 200) {
        const {
          selectOptions = [],
          firstValue = ""
        } = getSvgOptions(res?.data?.data, 'DistributionDiagram')
        this.options = selectOptions
        this.svgUrl = firstValue
      } else {
        console.log("获取svgSelectOptions失败");
      }
    },
  },
  computed: {
    // svgUrl: function () {
    //   return this.cascaderValue?.[this.cascaderValue.length - 1] || ""
    // }
    svgUrlType: function () {
      return this.svgUrl.includes("@/assets") ? "path" : "url"
    }
  },
  created() {
    this.getStationAttrs()
  },
  mounted() {

  },
  watch: {
    svgUrl(val) {
      this.svgKey = new Date().getTime()
    },

  }
}
</script>

<style lang="scss" scoped>
.photovoltaicDiagram {
  @include setPage;
  // width: 100%;
  // height: 100%;
  
  .title {
    text-align: center;
    height: 40px;
    // position: absolute;
    // left: 10px;
    // top: 70px;
  }

  .content {
    margin-top: 8px;
    height: calc(100% - 55px);
    // height: 100%;
    width: 100%;
  }
}
</style>